(function () {
    "use strict";

    var TxGroupViewPartControl = Solovis.defineClass(
        "Solovis.Reports.Parts.Other.TxGroupViewPartControl",
        Solovis.Reports.Parts.PartControl,
        function (options) {
            var self = this;

            this._txIdGetter = options.settings.transactionId;
        });

    TxGroupViewPartControl.requiredModules = ["Solovis.TxEditors"];

    TxGroupViewPartControl.prototype.doInit = function () {
    };

    TxGroupViewPartControl.prototype.doRender = function () {        
        if (!this._txGroupControlHost) {
            var txGroupDiv = $("<div>").appendTo(this.container);

            this._txGroupControlHost = new Solovis.UI.ControlHost({ container: txGroupDiv });            
        }

        var txId = this._txIdGetter.call(this);

        var txGroupViewControl = new (Solovis.Site as any).TxEditors.TxGroupViewControl({
            txId: txId
        });

        this._txGroupControlHost.setCurrentControl(txGroupViewControl);
    };    

})();